/* grunge-v4.js — comportements des blocs repris de produitv4.html.
   Quatre morceaux indépendants, tous délégués depuis le document : un bloc
   ajouté après coup dans l'éditeur fonctionne sans rechargement.
   Tout est en capture pour ne pas dépendre de la propagation du thème. */
(function () {
  if (window.__grungeV4Init) return;
  window.__grungeV4Init = true;

  /* ── 1. Onglets ─────────────────────────────────────────────────────── */
  function activerOnglet(liste, bouton) {
    var racine = liste.closest('.gv4-tabs');
    liste.querySelectorAll('button[role="tab"]').forEach(function (b) {
      var actif = b === bouton;
      b.setAttribute('aria-selected', actif ? 'true' : 'false');
      b.tabIndex = actif ? 0 : -1;
      var panneau = racine.querySelector('#' + b.getAttribute('aria-controls'));
      if (panneau) panneau.hidden = !actif;
    });
  }

  document.addEventListener('click', function (evt) {
    var onglet = evt.target.closest('.gv4-tabs__list button[role="tab"]');
    if (onglet) {
      activerOnglet(onglet.parentElement, onglet);
      return;
    }
    var plus = evt.target.closest('.gv4-tabs__more');
    if (plus) {
      var bloc = plus.closest('.gv4-tabs');
      var ouvert = bloc.classList.toggle('is-open');
      plus.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      var texte = plus.querySelector('span');
      if (texte) texte.textContent = ouvert ? (plus.dataset.lessLabel || 'Voir moins') : (plus.dataset.moreLabel || 'Voir plus');
    }
  }, true);

  // flèches gauche/droite entre onglets, comme l'attend un tablist
  document.addEventListener('keydown', function (evt) {
    var onglet = evt.target.closest && evt.target.closest('.gv4-tabs__list button[role="tab"]');
    if (!onglet || (evt.key !== 'ArrowRight' && evt.key !== 'ArrowLeft')) return;
    var tous = Array.prototype.slice.call(onglet.parentElement.querySelectorAll('button[role="tab"]'));
    var i = tous.indexOf(onglet) + (evt.key === 'ArrowRight' ? 1 : -1);
    var cible = tous[(i + tous.length) % tous.length];
    activerOnglet(onglet.parentElement, cible);
    cible.focus();
    evt.preventDefault();
  }, true);

  /* ── 2. Code promo : copie et confirmation directement dans le bouton ── */
  document.addEventListener('click', function (evt) {
    var bouton = evt.target.closest('.gv4-promo__code');
    if (!bouton) return;
    evt.preventDefault();

    var code = (bouton.getAttribute('data-code') || '').trim();
    if (!code) return;
    var statut = bouton.parentElement.querySelector('[data-gv4-statut]');
    var libelle = bouton.querySelector('[data-gv4-promo-code]');

    function dit(message) { if (statut) statut.textContent = message; }
    function montreCopie() {
      if (!libelle) return;
      window.clearTimeout(bouton.__gv4PromoTimer);
      libelle.textContent = 'COPIÉ';
      bouton.classList.add('is-copied');
      bouton.__gv4PromoTimer = window.setTimeout(function () {
        libelle.textContent = code;
        bouton.classList.remove('is-copied');
      }, 2000);
    }
    function copieDeSecours(texte) {
      var champ = document.createElement('textarea');
      champ.value = texte;
      champ.readOnly = true;
      champ.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
      document.body.appendChild(champ);
      champ.select();
      champ.setSelectionRange(0, texte.length);
      var copie = false;
      try { copie = document.execCommand('copy'); } catch (erreur) {}
      champ.remove();
      return copie;
    }
    function confirmeCopie() {
      montreCopie();
      dit('Code copié');
    }
    function essaieSecours() {
      if (copieDeSecours(code)) confirmeCopie();
      else dit('Code : ' + code);
    }

    if (window.isSecureContext && navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(confirmeCopie, essaieSecours);
    } else {
      essaieSecours();
    }
  }, true);
  /* ── 3. Mini avis : carrousel ────────────────────────────────────────── */
  function montre(bloc, index) {
    var figures = bloc.querySelectorAll('.gv4-mini__q figure');
    if (!figures.length) return;
    var i = (index + figures.length) % figures.length;
    figures.forEach(function (f, n) {
      if (n === i) f.setAttribute('data-on', 'true');
      else f.removeAttribute('data-on');
    });
    bloc.querySelectorAll('.gv4-mini__dots button').forEach(function (d, n) {
      d.setAttribute('aria-current', n === i ? 'true' : 'false');
    });
    bloc.setAttribute('data-index', String(i));
  }

  document.addEventListener('click', function (evt) {
    var bloc = evt.target.closest('.gv4-mini');
    if (!bloc) return;
    var i = Number(bloc.getAttribute('data-index') || 0);
    if (evt.target.closest('[data-gv4-prev]')) montre(bloc, i - 1);
    else if (evt.target.closest('[data-gv4-next]')) montre(bloc, i + 1);
    else {
      var point = evt.target.closest('.gv4-mini__dots button');
      if (point) montre(bloc, Number(point.getAttribute('data-i')));
    }
  }, true);

  /* ── 4. Vidéos : lecture automatique en boucle ───────────────────────
     Les vidéos démarrent seules (autoplay muted loop posé dans le Liquid).
     Le bouton ▶ n'est plus le déclencheur normal, c'est le SECOURS : iOS en
     mode économie d'énergie et les navigateurs à autoplay désactivé refusent
     le démarrage, et la vignette resterait figée sans moyen de la lancer.
     On écoute donc play/pause sur les vidéos elles-mêmes plutôt que le seul
     clic : sinon l'incrustation ▶ resterait affichée par-dessus une vidéo qui
     tourne déjà. Ces deux événements ne remontent pas (pas de bubbling) —
     d'où l'écoute en phase de CAPTURE. */
  ['play', 'pause'].forEach(function (nom) {
    document.addEventListener(nom, function (evt) {
      var video = evt.target;
      if (!video || video.tagName !== 'VIDEO') return;
      var reel = video.closest('.gv4-reel');
      if (reel) reel.classList.toggle('is-playing', nom === 'play');
    }, true);
  });

  document.addEventListener('click', function (evt) {
    var bouton = evt.target.closest('.gv4-reel__play button');
    if (!bouton) return;
    var reel = bouton.closest('.gv4-reel');
    var video = reel && reel.querySelector('video');
    if (!video) return;
    /* La classe .is-playing est posée par les écouteurs play/pause ci-dessus,
       pas ici : elle doit refléter l'état réel de la vidéo, y compris quand
       c'est l'autoplay — et non un clic — qui l'a lancée. */
    if (video.paused) { video.play().catch(function () {}); } else { video.pause(); }
  }, true);
})();
